import Highcharts from 'highcharts';
import {standardChart, numberRange} from './utilities';

export const figure54 = {
      ...standardChart,
      xAxis: [{
        categories: numberRange(2012, 2021),
        tickInterval: 1,
        title: {
            text: "Año",
            offset: 80,
            style: {
                fontSize:'18px',
                color: Highcharts.getOptions().colors[1]
            }
        },
        crosshair: {
            width: 1,
            color: '#d7d7d7'
        },
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
            y: 32,
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            }
        },
    }],

    yAxis: [
        {
        labels: {
            format: '{value}',
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            },
        },
        offset: 10,
        gridLineWidth: 2,
        max: 90000,
        min: 0,
        tickInterval: 10000,
        title: {
            text: "ANTM",
            offset: 80,
            style: {
                fontSize:'18px',
                color: Highcharts.getOptions().colors[1]
            }
        }
    }],
    tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
            padding: 0
        }
    },
    plotOptions: {
        series: {
            states: {
                hover: {
                    lineWidth: 2
                }
            },
            marker: {
                symbol: 'circle',
                states: {
                    hover: {
                        enabled: true,
                        radius: 5
                    }
                }
            }
        }
    },
    series: [ 
        {
        name: 'Mundo',
        type: 'line',
        color: '#4f81bd',
        zoneAxis: 'x',
        data: [
          { y: 33691, dataLabels: {enabled:true} },
          { y: 40645, dataLabels: {enabled:true} },
          { y: 47755, dataLabels: {enabled:true} },
          { y: 55352, dataLabels: {enabled:true} },
          { y: 62436, dataLabels: {enabled:true} },
          { y: 68177, dataLabels: {enabled:true} },
          { y: 73136, dataLabels: {enabled:true} },
          { y: 77271, dataLabels: {enabled:true} },
          { y: 78094, dataLabels: {enabled:true} },
          { y: 78108, dataLabels: {enabled:true} },
        ],
    },
    {
        marker: {
            enabled: false
        },
        name: 'África septentrional',
        type: 'line',
        color: '#c0504d',
        zoneAxis: 'x',
        data: [
            2564,
            2963,
            3343,
            3658,
            3824,
            3955,
            4022,
            4106,
            4106,
            4106
        ],
    },
    {
        marker: {
            enabled: false
        },
        name: 'Australia y Nueva Zelandia',
        type: 'line',
        color: '#b2cb80',
        zoneAxis: 'x',
        data: [
            293,
            336,
            384,
            458,
            532,
            609,
            679,
            709,
            711,
            711
        ],
    },

    {
        marker: {
            enabled: false
        },
        name: 'Asia central y meridional',
        type: 'line',
        color: '#a794bf',
        zoneAxis: 'x',
        data: [
            7257,
            8774,
            10206,
            12001,
            13662,
            15007,
            16068,
            17017,
            17056,
            17056
         ],
    },
    {
        marker: {
            enabled: false
        },
        name: 'Asia occidental',
        type: 'line',
        color: '#4bacc6',
        zoneAxis: 'x',
        data: [
            2287,
            2670,
            3087,
            3540,
            3723,
            3919,
            4051,
            4190,
            4193,
            4193,
        ],
    },
    {
        marker: {
            enabled: false
        },
        name: 'África subsahariana',
        type: 'line',
        color: '#f79646',
        zoneAxis: 'x',
        data: [
            3177,
            3813,
            4575,
            5287,
            6198,
            7152,
            8028,
            8681,
            8723,
            8723
        ],
    },

    {
        marker: {
            enabled: false
        },
        name: 'América Latina y el Caribe',
        type: 'line',
        color: '#6a819d',
        zoneAxis: 'x',
        data: [
            4528,
            5391,
            6230,
            6891,
            7645,
            8195,
            8807,
            9371,
            9381,
            9381            
        ],
    },


    {
        marker: {
            enabled: false
        },
        name: 'Oceanía (excluidas Australia y Nueva Zelandia)',
        type: 'line',
        color: '#a97978',
        zoneAxis: 'x',
        data: [
            32,
            61,
            70,
            75,
            79,
            79,
            79,
            81,
            81,
            81
        ],
    },


    {
        marker: {
            enabled: false
        },
        name: 'Asia oriental y Asia sudoriental',
        type: 'line',
        color: '#5f7530',
        zoneAxis: 'x',
        data: [
            2833,
            3398,
            4088,
            4745,
            5272,
            5818,
            6265,
            6474,
            6528,
            6528
        ],
    },

  ],

}